import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Customer } from '../model/customer';
// import { Project } from '@src/app/components/org/orgprojectpub/model/project';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { CustomerUser } from '@src/app/models/customeruser';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomeruserlistService {
  serviceUrl:string = environment.apiUrl+'/organization/' + SessionHelper.getChoosenOrg()+'/customer/';
  constructor(private http:HttpClient) { }

  getUsers(customer:Customer,pit:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<CustomerUser[]>(this.serviceUrl+customer.customerId.substring(0,36)+'/user/list/pit/'+pit,httpOptions)


  }
  deleteCustomerUser(customerUser:CustomerUser){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete(environment.apiUrl+
      '/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+
      customerUser.customerId+
      '/user/'
      +customerUser.userId,httpOptions);
  }
}
